<template>
  <div>
    <multiselect
      v-model="selected"
      @input="onChange"
      :options="options"
      selectLabel=""
      :custom-label="labelEsporte"
      selectedLabel="«"
      deselectLabel=""
      :allowEmpty="true"
      :preselectFirst="true"
      :loading="isLoading"
      track-by="id"
      :disabled="isDisabled"
      placeholder=""
    >
      <template slot="noResult" slot-scope="props">
        <span>{{ $t('Nenhum elemento encontrado') }}.</span>
      </template>
      <template slot="noOptions" slot-scope="props">
        <span>{{ $t('Nenhum dado foi retornado') }}.</span>
      </template>
      <template slot="placeholder" slot-scope="props">
        <span>{{ $t(emptyLabel) }}</span>
      </template>
    </multiselect>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'customPlaceholder',
    'setDefault',
    'isSpecialSports',
    'relatedIdAlias',
    'customLabel',
    'isObject',
    'onlyBetBuilder'
  ],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    labelEsporte({ nome }) {
      return `${nome}`;
    },
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_esporte', null);
        return;
      }
      this.$emit('selectChange', this.customLabel || 'id_esporte', this.isObject == true ? e : e.id);
    },
    setValue(value) {
      if (value) {
        if (this.isObject) {
          this.selected = this.options.find((option) => option.id === value.id);
        } else {
          this.selected = this.options.find((option) => option.id === value);
        }
      } else {
        if (this.setDefault) {
          this.selected = this.options[0];
          this.onChange(this.selected);
        } else {
          this.selected = this.options.find((option) => option.id === null);
        }
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      const idEmpresa = this.$util.getIdEmpresa();
      let where = `id_empresa = ${idEmpresa}`;
      let related = 'tipo_esporte:nome as nome';

      if (this.isSpecialSports) {
        where += ` and data_source.fornecedor.id_fornecedor_origem = 8 AND data_source.fornecedor.ids_empresa @> '[${idEmpresa}]'`;
        related += `|data_source_esporte:id as ${this.relatedIdAlias || 'idEsporte'}|`;
        related += 'fornecedor:id as fornecedor_id';
      }

      if (this.onlyBetBuilder === true) {
        where += ' and betbuilder is true';
      }

      this.isLoading = true;
      this.$atenaList
        .getCommon('esporte_empresa', {
          columns: 'id_tipo_esporte AS id',
          filter: where,
          related: related,
          order: 'nome'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.customPlaceholder || this.$i18n.t('Todos') }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  },
  created() {
    this.setOptions();
  }
};
</script>

<style lang="scss" scoped></style>
